<template>
    <div class="color_bubble" v-bind:class="colorBubbleVariant">
        <div class="row align-items-center">
            <div class="icon_column col col-1 text-center">
                <slot name="icon"></slot>
            </div>
            <div class="col heading bold" v-bind:class="colorBubbleColumn1">
                <slot name="heading"></slot>
            </div>
            <div class="col description text-end" v-bind:class="colorBubbleColumn2">
                <slot name="description"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "color-bubble",
    props: {
        variant: { type: String },
        ratio: { type: String },
    },
    computed: {
        colorBubbleVariant: function () {
            return "color_bubble_" + this.variant;
        },
        colorBubbleColumn1: function () {
            if (this.ratio == "half") {
                return "col-5";
            }

            return "col-7";
        },
        colorBubbleColumn2: function () {
            if (this.ratio == "half") {
                return "col-6";
            }

            return "col-4";
        },
    },
};
</script>

<style lang="scss">
@use "@/scss/custom";
.color_bubble {
    color: white;
    border-radius: 10px;
    padding: 25px 15px;
    margin-bottom: 20px;
}

.color_bubble .heading {
    font-family: custom.$font-family-base;
    font-size: 18px;
    padding-left: 0px;
}

.color_bubble_blue {
    background-color: custom.$color-blue;
}

.color_bubble_yellow {
    background-color: custom.$color-yellow;
}

.color_bubble_green {
    background-color: custom.$color-green;
}

.color_bubble_orange {
    background-color: custom.$color-orange;
}

.color_bubble_beige {
    background-color: custom.$color-beige;
}

.color_bubble_dark {
    background-color: custom.$dark;
}

.icon_column {
    width: 60px;
    padding: 0px;
    font-size: 24px;
    position: relative;
    top: 2px;
}

@media (max-width: 575.98px) {
    .color_bubble .description {
        padding-left: 0px;
    }
}
</style>
